export default __webpack_public_path__ + "static/media/PH.df9efebc.svg";